/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CloseAccountRequest} from '@cash-web/protos/squareup/franklin/app/account.pb'
import {CloseAccountResponse} from '@cash-web/protos/squareup/franklin/app/account.pb'


export const closeAccount = (request:CloseAccountRequest, options?: CashRequestOptions) => post<CloseAccountRequest, CloseAccountResponse>("/2.0/cash/close-account", request, {...options, rejectOnError: true })